function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8421 17.082L13.4678 12.7078C14.6412 11.3588 15.3516 9.59867 15.3516 7.67494C15.3516 3.44035 11.9073 0 7.67665 0C3.44206 0 0.00170898 3.44435 0.00170898 7.67494C0.00170898 11.9055 3.44605 15.3499 7.67665 15.3499C9.60038 15.3499 11.3605 14.6395 12.7095 13.4661L17.0837 17.8404C17.1875 17.9441 17.3272 18 17.4629 18C17.5986 18 17.7383 17.9481 17.8421 17.8404C18.0496 17.6328 18.0496 17.2896 17.8421 17.082ZM1.07532 7.67494C1.07532 4.03503 4.03674 1.07761 7.67266 1.07761C11.3126 1.07761 14.27 4.03902 14.27 7.67494C14.27 11.3109 11.3126 14.2763 7.67266 14.2763C4.03674 14.2763 1.07532 11.3149 1.07532 7.67494Z"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#6D7F92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.500f03cc.svg";
export { ForwardRef as ReactComponent };